import React from 'react';
import { connect } from 'react-redux';
import FilterFreeTrialListIpb from './components/FilterFreeTrialListIpb';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import { useFreeTrialListIpb } from './hooks/useFreeTrialListIpb';
import DataTable from 'widgets/datagrid/DataTable';
import CustomDialog from 'widgets/component/CustomDialog';
import FreeTrialOrderDetailContent from './components/FreeTrialOrderDetailContent';
import EmailActions from './components/EmailActions';
import ChangeEmailAction from './components/ChangeEmailAction';
import { listFreeTrialIpbAction } from '_models/redux/free-trial-list-ipb/action';
import { cleanListFreeTrialIpbClean } from '_models/redux/free-trial-list-ipb/clean-action';
import { detailFreeTrialIpbAction } from '_models/redux/detail-free-trial-ipb/action';
import { cleanDetailFreeTrialIpbAction } from '_models/redux/detail-free-trial-ipb/clean-action';
import { updateEmailAction, resendEmailAction } from '_models/redux/email-free-trial-ipb/action';

const PageFreeTrialListIpb = ({
  listFreeTrialIpbAction,
  listFreeTrialIpb,
  cleanListFreeTrialIpbClean,
  detailFreeTrialIpbAction,
  detailFreeTrialIpb,
  cleanDetailFreeTrialIpbAction,
  updateEmailAction,
  resendEmailAction,
  transactionId,
  onClose,
  emailFreeTrialIpb,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    getBackgroundColor,
    refetchDetails,
    handleUpdateEmail,
    handleResendEmail,
  } = useFreeTrialListIpb({
    listFreeTrialIpbAction,
    listFreeTrialIpb,
    cleanListFreeTrialIpbClean,
    detailFreeTrialIpbAction,
    detailFreeTrialIpb,
    cleanDetailFreeTrialIpbAction,
    updateEmailAction,
    resendEmailAction,
    transactionId,
    onClose,
    emailFreeTrialIpb,
  });

  return (
    <>
      <Grid>
        <h4>Prueba Gratis IPB</h4>
      </Grid>
      <Grid marginBottom={4}>
        <FilterFreeTrialListIpb
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <Grid>
        <>
          {mappedRows?.length > 0 ? (
            <Box>
              <DataTable
                rows={mappedRows}
                columns={Columns}
                onRowClick={handleRowClick}
                page={page}
                pageSize={size}
                rowCount={pagination?.total_rows ?? 0}
                onPageChange={pagination?.handleChangePage}
                handleChangePageSize={pagination?.handleChangePageSize}
                getBackgroundColor={getBackgroundColor}
                mappedRows={mappedRows}
                loading={loading}
              />
            </Box>
          ) : (
            <Typography variant='h6'>No hay registros disponibles</Typography>
          )}
        </>
      </Grid>

      <CustomDialog
        fullWidth
        title={
          detailFreeTrialIpb?.response?.payment_info === null
            ? 'No hay datos'
            : 'Detalle Prueba Gratis IPB'
        }
        content={
          <>
            <FreeTrialOrderDetailContent
              orderDetails={detailFreeTrialIpb?.response?.order_detail}
            />
            <ChangeEmailAction
              handleUpdateEmailAction={handleUpdateEmail}
              refetchDetails={refetchDetails}
              handleResendEmail={handleResendEmail}
            />
            <EmailActions
              handleUpdateEmail={handleUpdateEmail}
              refetchDetails={refetchDetails}
              handleResendEmail={handleResendEmail}
            />
          </>
        }
        open={isDialogOpenDetails}
        onClose={handleClose}
        maxWidth='md'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />

      <CustomDialog
        title='Mensaje'
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  listFreeTrialIpb: state?.listFreeTrialIpb,
  detailFreeTrialIpb: state?.detailFreeTrialIpb,
  emailFreeTrialIpb: state?.emailFreeTrialIpb,
});

const mapDispatchToProps = {
  listFreeTrialIpbAction,
  cleanListFreeTrialIpbClean,
  detailFreeTrialIpbAction,
  cleanDetailFreeTrialIpbAction,
  updateEmailAction,
  resendEmailAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageFreeTrialListIpb);
